import { useEffect, useMemo, useState } from "react"
import { OpfBase } from "../../../types"
import api from "../../../services/api"
import { useSelector } from "react-redux"
import selectors from "../../../store/selectors"

export const useProcessItems = (initialSlugs: string[]) => {
  const applicationContext = useSelector(selectors.getApplicationContext)
  const [isLoading, setIsLoading] = useState(false)
  const [map, setMap] = useState<Map<string, OpfBase>>(new Map())

  const addItem = (opfItem: OpfBase, map: Map<string, OpfBase>) => {
    const { opfChildren = [], ...item } = opfItem
    map.set(item.opfId, item)
    opfChildren?.forEach((opfChild) => addItem(opfChild, map))
  }

  const loadProcessItem = async (slug: string) => {
    try {
      const { data } = await api().items.getItemBySlug({ slug, level: 1, applicationContext })
      setMap((map) => {
        data.opfItems.forEach((opfItem: OpfBase) => addItem(opfItem, map))
        return new Map(map)
      })
    } catch {}
  }

  const loadInitialItems = async () => {
    setIsLoading(true)
    const rootSlug = ""
    await Promise.all([rootSlug, ...initialSlugs].map(loadProcessItem))
    setIsLoading(false)
  }

  useEffect(() => {
    void loadInitialItems()
  }, [])

  const processItems = useMemo(() => [...map.values()], [map])

  return {
    isLoading,
    processItems,
    loadProcessItem,
  }
}
